<p-dialog
  modal="true"
  header="{{ 'revenue.invoice-selector.actions.write-off-invoices' | translate | titlecase }}" [(visible)]="writeOffInvoicesCheck"
  [closable]="true"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [contentStyle]="{ 'min-height': '50vh' }"
>
  <div class="mct-flex mct-col mct-gap-27"  >
    <div class="mct-flex mct-row mct-wrap mct-gap-7"  >
      <div class="mct-flex mct-col" >
        <label>{{ 'invoices.invoice-builder.adjustments-tab.adjustment-date' | translate | titlecase }}</label>
        <wl-date-selector [(ngModel)]="writeOffDto.AdjustmentDate"></wl-date-selector>
      </div>
      <div class="mct-flex mct-col" >
        <label>{{ 'invoices.invoice-builder.adjustments-tab.apply-date' | translate | titlecase }}</label>
        <wl-date-selector [(ngModel)]="writeOffDto.ApplyDate"></wl-date-selector>
      </div>
    </div>
    <div class="mct-flex mct-col mct-gap-27 write-off-half-gt-sm"   >
      <div>
        <label>{{ 'invoices.invoice-builder.adjustments-tab.adjustment-type' | translate | titlecase }}</label>
        <p-select
          [(ngModel)]="writeOffDto.AdjustmentTypeId"
          placeholder="{{ 'invoices.invoice-builder.select-label' | translate }}"
          [options]="adjustmentTypes"
          optionLabel="AdjustmentType"
          optionValue="AdjustmentTypeId"
          [style]="{ width: '100%' }"
        ></p-select>
      </div>
      <div>
        <label style="width: 100%">{{ 'invoices.invoice-builder.adjustments-tab.adjustment-descr' | translate | titlecase }}</label>
        <input [(ngModel)]="writeOffDto.Description" type="text" class="form-input" style="width: 100%" />
      </div>
      <div>
        <label style="width: 100%">{{ 'revenue.invoice-selector.actions.reference-number' | translate | titlecase }}</label>
        <input [(ngModel)]="writeOffDto.ReferenceNumber" type="number" class="form-input" style="width: 100%" />
      </div>
      <div>
        <label style="width: 100%"
          >{{ 'revenue.invoice-selector.actions.warning-for-write-off' | translate }}
          <strong>{{ 'common.action-cannot-be-undone-warning' | translate }}</strong>
        </label>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-justify-end mct-items-stretch mct-gap-7"   style="width: 100%" >
      <button pButton type="button" class="btn btn-secondary" (click)="cancelInvoiceWriteOff()">
        <i class="pi pi-times"></i>
        {{ 'common.cancel' | translate | titlecase }}
      </button>
      <button pButton type="button" class="btn btn-primary" (click)="writeOff()" [disabled]="isGenerating">
        <wl-busy [show]="isGenerating"></wl-busy>
        {{ 'revenue.invoice-selector.actions.adjust-invoices' | translate | titlecase }}
      </button>
    </div>
  </ng-template>
</p-dialog>
